module.exports = __webpack_public_path__ + "img/q4.8b941050.svg";